import React, { useEffect, useState } from 'react'

export default function TableSort(props) {
    const {total} = props
    
    const [selectedValue, setSelectedValue] = useState()
    
    useEffect(() => {
        props.sendToParent(selectedValue)
    }, [props, selectedValue])
    
    const handleSortValue = (e) => {
        setSelectedValue(e.target.value)
    }

    return (
        <select id="sorter" class="sorter-options" onChange={handleSortValue}>
            <option value="position" selected>Alphabetical</option>
            {
                total ? <>
                <option value="total-teus">Highest Total TEUS</option>
                <option value="total-tons">Highest Total TONS</option>
                </>
                : ''
            } 
            <option value="import-tons">Highest Import TONS</option>
            <option value="export-tons">Highest Export TONS</option>
            <option value="import-teus">Highest Import TEUS</option>
            <option value="export-teus">Highest Export TEUS</option>
        </select>
    )
}